import React, { useState } from 'react';
import { FileText, FileEdit, User, X } from 'lucide-react';
import AppoinmentDetails from './AppoinmentDetails';
import CreatePrescription from './CreatePrescription';
import './ConsultationSidePanel.scss';
import { AppoinmentDetailIcon } from './Icons';

const ConsultationSidePanel = ({ appointmentData, onClose, activeTabProp }) => {
    console.log('Appointment Data:', appointmentData);
    const [activeTab, setActiveTab] = useState(activeTabProp||'info'); // 'info' or 'prescription'

    return (
        <div className="consultation-side-panel">
            <button 
                className="close-button"
                onClick={onClose}
                aria-label="Close panel"
            >
                <X size={20} />
            </button>
            
            {/* Content Area */}
            <div className="panel-content">
                {activeTab === 'info' ? (
                    <AppoinmentDetails appointmentData={appointmentData} />
                ) : (
                    <CreatePrescription onBack={() => setActiveTab('info')} />
                )}
            </div>

            {/* Bottom Tabs */}
            <div className="bottom-tabs">
                <button
                    onClick={() => onClose()}
                    // onClick={() => setActiveTab('info')}
                    className={`tab-button ${activeTab === 'info' ? 'active' : 'inactive'}`}
                >
                    <div className="control-button">

                    <div className="icon-wrapper">
                        <AppoinmentDetailIcon className={activeTab === 'info' ? "text-blue-500" : "text-white"} />

                    </div>
                   <div className="text-wrapper">
                        <div>Appointment</div>
                        <div>Information</div>
                   </div>
                   </div>
                </button>
               
                {/* <button
                    onClick={() => setActiveTab('prescription')}
                     className={`tab-button border-left ${activeTab === 'prescription' ? 'active' : 'inactive'}`}
                >
                    <div className="icon-wrapper">
                        <FileEdit size={24} className={activeTab === 'prescription' ? "text-blue-500" : "text-white"} />
                    </div>
                     <div className="text-wrapper">
                        <div>Create a</div>
                        <div>Prescription</div>
                   </div>
                </button> */}
            </div>
        </div>
    );
};

export default ConsultationSidePanel;
